export default __webpack_public_path__ + "static/media/Traspaso- Sin nombre de AFORE ‐ Made with Clipchamp.10b6c986.mp3";